const Experiences = [
  {
    company: 'ATNS',
    url: 'https://atns.io/',
    job: 'Software Engineer',
    from: '06/2026',
    to: 'Present'
  },
  {
    company: 'Anyjoi',
    url: 'https://anyjoi.com',
    job: 'Software Engineer',
    from: '11/2023',
    to: '06/2026'
  },
  {
    company: 'Superjoi',
    url: 'https://superjoi.com',
    job: 'Software Engineer',
    from: '06/2022',
    to: '11/2023'
  },
  {
    company: 'PVcomBank',
    url: 'https://www.pvcombank.com.vn',
    job: 'Software Engineer',
    from: '03/2022',
    to: '06/2023'
  },
  {
    company: 'CMC Global',
    url: 'https://cmcglobal.com.vn',
    job: 'Software Engineer',
    from: '06/2020',
    to: '12/2021'
  }
]

export default Experiences
